import { render, staticRenderFns } from "./Gem.vue?vue&type=template&id=d7f396e8&scoped=true"
import script from "./Gem.vue?vue&type=script&lang=js"
export * from "./Gem.vue?vue&type=script&lang=js"
import style0 from "./Gem.vue?vue&type=style&index=0&id=d7f396e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f396e8",
  null
  
)

export default component.exports